module.exports = __webpack_public_path__ + "img/anandalab-logo.0df35d09.png";